import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { AxiosRequestConfig, Method } from 'axios'

import { IProcedureResponse } from 'clickNgo/models/api'

import { callProcedure } from './callProcedure'

interface BaseQueryFnParameters {
  url: string
  method?: Method
  data?: AxiosRequestConfig['data']
  params?: AxiosRequestConfig['params']
  headers?: AxiosRequestConfig['headers']
}

export const axiosProcedureQuery = <T>(): BaseQueryFn<
  BaseQueryFnParameters,
  IProcedureResponse<T>
> => {
  return async (parameters) => {
    return await callProcedure<IProcedureResponse<T>>(parameters)
  }
}
